import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit-pen.svg';

const STYLES = {
  REVIEW_ITEM_CONTAINER: 'flex justify-between',
  REVIEW_ITEM_CONTAINER_BORDER: 'border-b-[1px] border-bw03',
  REVIEW_ITEM_HEADER: 'font-metricR text-bw07 text-[16px] flex items-center',
  REVIEW_AMOUNT: 'text-[22px] text-action03 font-metricRMedium',
  EDIT: 'font-metricR text-[16px] text-bw08 underline',
  SECTION_TITLE: 'font-metricRMedium text-bw08 text-[18px] leading-6',
  REVIEW_ITEM_KEY: 'font-metricR text-bw07 text-[16px] leading-6',
  REVIEW_ITEM_VALUE:
    'font-metricR text-bw08 text-[16px] leading-6 w-[200px] text-right items-center box-content tracking-[0.04em]',
};

interface IPayeeDetailsReviewProps {
  onEditPayeeDetailsClick: () => void;
  accountDetails: string;
  instituteName: string;
  accountNumber: string;
  routingNumber: string;
}
const PayeeDetailsReview = ({
  onEditPayeeDetailsClick,
  instituteName,
  accountDetails,
  accountNumber,
  routingNumber,
}: IPayeeDetailsReviewProps) => {
  // put "," before the last 4 numbers of account number
  accountNumber = accountNumber.replace(/(.*)(.{4})/, '$1, $2');
  const { t } = useTranslation();
  return (
    <div>
      <div className={`${STYLES.REVIEW_ITEM_CONTAINER} mb-[11px]`}>
        <Heading title={t('SEND_MONEY.REVIEW.PAYEE_DETAILS_TITLE')} className={STYLES.SECTION_TITLE} />
        <Button
          onClick={onEditPayeeDetailsClick}
          className='ml-[10px]'
          id=''
          testId='TransferReviewPage-editAmount'
          childElement={<EditIcon className='w-[24px] stroke-bw08' />}
        />
      </div>
      <div className={STYLES.REVIEW_ITEM_CONTAINER}>
        <Heading
          title={t('SEND_MONEY.REVIEW.ITEMS.SEND_TO')}
          className={`${STYLES.REVIEW_ITEM_KEY} flex items-center`}
        />
        <div>
          <Heading testId='payeeBankName' title={instituteName} className={STYLES.REVIEW_ITEM_VALUE} />
          <Heading testId='payeeAccountDetails' title={accountDetails} className={STYLES.REVIEW_ITEM_VALUE} />
        </div>
      </div>
      <div className={`${STYLES.REVIEW_ITEM_CONTAINER} mt-[10px]`}>
        <Heading title={t('SEND_MONEY.REVIEW.ITEMS.ACCOUNT_NUMBER')} className={STYLES.REVIEW_ITEM_KEY} />
        <Heading testId='accNumberReview' title={accountNumber} className={STYLES.REVIEW_ITEM_VALUE} />
      </div>
      <div className={`${STYLES.REVIEW_ITEM_CONTAINER} mt-[10px]`}>
        <Heading title={t('SEND_MONEY.REVIEW.ITEMS.ROUTING_NUMBER')} className={STYLES.REVIEW_ITEM_KEY} />
        <Heading testId='routNumberReview' title={routingNumber} className={STYLES.REVIEW_ITEM_VALUE} />
      </div>
    </div>
  );
};
export default PayeeDetailsReview;
